import { Action } from '@ngrx/store';
import { Agent } from '../../_models/agent';

export enum AgentActitonTypes {

  ClearAgent = '[Agent] Clear',
  InicializeAgent = '[Agent] Inicialize',

	SetCurrentAgent = '[Agent] Set Current',
	SetCurrentAgentId = '[Agent] Set Current Id',

	SetFilterFields = '[Agent] Set Filter Fields',

	LoadAgents = '[Agent] Get List',
	LoadAgentsSuccess = '[Agent] Load Success',
  LoadAgentsFail = '[Agent] Load Fail',

  UpdateAgent = '[Agent] Update',
  UpdateAgentSuccess = '[Agent] Update Success',
	UpdateAgentFail = '[Agent] Update Fail',

	CreateAgent = '[Agent] Create',
  CreateAgentSuccess = '[Agent] Create Success',
	CreateAgentFail = '[Agent] Create Fail',

	DeleteAgent = '[Agent] Delete',
  DeleteAgentSuccess = '[Agent] Delete Success',
	DeleteAgentFail = '[Agent] Delete Fail',
}

export class ClearAgent implements Action {
	readonly type = AgentActitonTypes.ClearAgent;
}

export class InicializeAgent implements Action {
	readonly type = AgentActitonTypes.InicializeAgent;
}

export class SetCurrentAgent implements Action {
	readonly type = AgentActitonTypes.SetCurrentAgent;

	constructor(public payload: Agent) {}
}

export class SetCurrentAgentId implements Action {
	readonly type = AgentActitonTypes.SetCurrentAgentId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = AgentActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadAgents implements Action {
	readonly type = AgentActitonTypes.LoadAgents;

	constructor(public payload: any) {}
	// constructor(public payload: {
    //   finished: boolean,
    //   searchDesc: string,
    //   searchName: string
    // }) {}
}

export class LoadAgentsSuccess implements Action {
	readonly type = AgentActitonTypes.LoadAgentsSuccess;

	constructor(public payload: Agent[]) {}
}

export class LoadAgentsFail implements Action {
	readonly type = AgentActitonTypes.LoadAgentsFail;

	constructor(public payload: string) {}
}

export class UpdateAgent implements Action {
	readonly type = AgentActitonTypes.UpdateAgent;

	constructor(public payload: Agent) {}
}

export class UpdateAgentSuccess implements Action {
	readonly type = AgentActitonTypes.UpdateAgentSuccess;

	constructor(public payload: Agent) {}
}

export class UpdateAgentFail implements Action {
	readonly type = AgentActitonTypes.UpdateAgentFail;

	constructor(public payload: string) {}
}

export class DeleteAgent implements Action {
	readonly type = AgentActitonTypes.DeleteAgent;

	constructor(public payload: Agent) {}
}

export class DeleteAgentSuccess implements Action {
	readonly type = AgentActitonTypes.DeleteAgentSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteAgentFail implements Action {
	readonly type = AgentActitonTypes.DeleteAgentFail;

	constructor(public payload: string) {}
}

export class CreateAgent implements Action {
	readonly type = AgentActitonTypes.CreateAgent;

	constructor(public payload: Agent) {}
}

export class CreateAgentSuccess implements Action {
	readonly type = AgentActitonTypes.CreateAgentSuccess;

	constructor(public payload: Agent) {}
}

export class CreateAgentFail implements Action {
	readonly type = AgentActitonTypes.CreateAgentFail;

	constructor(public payload: string) {}
}


// Unión de acciones
export type AgentActions = ClearAgent
| InicializeAgent
| SetCurrentAgent
| SetCurrentAgentId
| SetFilterFields
| LoadAgents
| LoadAgentsSuccess
| LoadAgentsFail
| UpdateAgent
| UpdateAgentSuccess
| UpdateAgentFail
| CreateAgent
| CreateAgentSuccess
| CreateAgentFail
| DeleteAgent
| DeleteAgentSuccess
| DeleteAgentFail
| LoadAgents
| LoadAgentsSuccess
| LoadAgentsFail;
